import React, { useEffect } from "react";
import * as Actions from "../../Store/Actions";
import EventEmitter, { Events } from "../../services/eventemitter";
import { useDispatch } from "react-redux";
import { LoginResponse } from "../../models";
import { utils } from "../../utils";

const Form = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        EventEmitter.on(Events.GetCannedMsgs, persistCannedMessage)
    }, []);


    const persistCannedMessage = (data) => {
        var dt = data?.data.data?.map(x => ({ ...x, messageText: x.descr, messageID: x.id, websiteId: x.webSiteId }))
        if(dt==undefined || dt==null){
            return;
        }
        
        if (utils.isElectronBuild()) {
            window?.myAPI?.send(JSON.stringify(dt));
        }
        else {
            dispatch(Actions.persistAllCannedMessage(dt));
        }
    }
    return <></>;
};
export default Form;